import { render } from "./RenameDeveloperModal.vue?vue&type=template&id=5add2697&scoped=true&lang=pug"
import script from "./RenameDeveloperModal.vue?vue&type=script&lang=js"
export * from "./RenameDeveloperModal.vue?vue&type=script&lang=js"

import "./RenameDeveloperModal.vue?vue&type=style&index=0&id=5add2697&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5add2697"]])

export default __exports__